import React from 'react';
import { useTranslation } from 'react-i18next';
import { PRODUCT_VIDEO_URL } from '../lib/productVideo.js';
import '../styles/product-video-link.css';

export default function ProductVideoLink() {
  const { t } = useTranslation();
  if (!PRODUCT_VIDEO_URL) return null;
  return (
    <a className="product-video-link" href={PRODUCT_VIDEO_URL} target="_blank" rel="noopener noreferrer">
      <svg className="product-video-link__icon" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M22 7.1a3 3 0 0 0-2.1-2.2C18 4.4 12 4.4 12 4.4s-6 0-7.9.5A3 3 0 0 0 2 7.1c-.5 1.9-.5 4.9-.5 4.9s0 3 .5 4.9a3 3 0 0 0 2.1 2.2c1.9.5 7.9.5 7.9.5s6 0 7.9-.5a3 3 0 0 0 2.1-2.2c.5-1.9.5-4.9.5-4.9s0-3-.5-4.9Z" />
        <path fill="var(--bg-elev, #fff)" d="m10 15.4 5.3-3.4L10 8.6v6.8Z" />
      </svg>
      <span>{t('productVideo.watch', { defaultValue: 'See Dathent in action' })}</span>
      <span className="product-video-link__duration">{t('productVideo.duration', { seconds: 41, defaultValue: '{{seconds}} sec' })}</span>
      <span aria-hidden="true">↗</span>
      <span className="product-video-link__sr">{t('productVideo.external', { defaultValue: '(YouTube, opens in a new tab)' })}</span>
    </a>
  );
}
